import { render, staticRenderFns } from "./Fatura.vue?vue&type=template&id=71d9a33f&scoped=true"
import script from "./Fatura.vue?vue&type=script&lang=js"
export * from "./Fatura.vue?vue&type=script&lang=js"
import style0 from "./Fatura.vue?vue&type=style&index=0&id=71d9a33f&prod&scoped=true&lang=css"
import style1 from "./Fatura.vue?vue&type=style&index=1&id=71d9a33f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d9a33f",
  null
  
)

export default component.exports